import { b as _typeof, a as _slicedToArray } from './_rollupPluginBabelHelpers-e71b1aad.js';
import { useCallback, useState, useEffect } from 'react';

function useWindowSize() {
  var isClient = (typeof window === "undefined" ? "undefined" : _typeof(window)) === 'object';
  var getSize = useCallback(function () {
    return {
      width: isClient ? window.innerWidth : undefined,
      height: isClient ? window.innerHeight : undefined
    };
  }, [isClient]);
  var _useState = useState(getSize),
    _useState2 = _slicedToArray(_useState, 2),
    windowSize = _useState2[0],
    setWindowSize = _useState2[1];
  useEffect(function () {
    if (!isClient) {
      return false;
    }
    function handleResize() {
      setWindowSize(getSize());
    }
    window.addEventListener('resize', handleResize);
    return function () {
      return window.removeEventListener('resize', handleResize);
    };
  }, [getSize, isClient]);
  return windowSize;
}

export { useWindowSize as u };
//# sourceMappingURL=useWindowSize-0dc36789.js.map
